import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import Badge from '@mui/material/Badge';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import NoteAltIcon from '@mui/icons-material/NoteAlt';

import MemoSection from './MemoSection.js'
import { fetchMemos } from './memoApi.js'

// タイトルバー等に置くメモアイコン（件数バッジ付き）。クリックでメモ欄をダイアログ表示する
// 対象の指定方法は MemoSection と同じ（personalCode または workplaceInstitutionCode）
export default function MemoIconButton(props) {
  const { token, personalCode, workplaceInstitutionCode, targetLabel, hospitalOptions } = props;

  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);

  const loadCount = useCallback(() => {
    const params = personalCode
      ? { personal_code: personalCode }
      : { workplace_institution_code: workplaceInstitutionCode };

    fetchMemos(token, params)
      .then((response) => setCount(response.data.count))
      .catch(() => setCount(0));
  }, [token, personalCode, workplaceInstitutionCode]);

  useEffect(() => {
    loadCount();
  }, [loadCount]);

  const handleClose = () => {
    setOpen(false);
    loadCount();
  };

  return (
    <>
      <Tooltip title="メモ">
        <IconButton color="inherit" aria-label="メモ" onClick={() => setOpen(true)}>
          <Badge badgeContent={count} color="error">
            <NoteAltIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle sx={{ pr: 6 }}>
          {targetLabel}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <MemoSection
            token={token}
            personalCode={personalCode}
            workplaceInstitutionCode={workplaceInstitutionCode}
            targetLabel={targetLabel}
            hospitalOptions={hospitalOptions}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

MemoIconButton.propTypes = {
  token: PropTypes.string.isRequired,
  personalCode: PropTypes.string,
  workplaceInstitutionCode: PropTypes.string,
  targetLabel: PropTypes.string,
  hospitalOptions: PropTypes.array,
};
